import { StyledGameAssetsLoader } from './GameAssetsLoader.styled';
import Image from 'next/image';
import { motion } from 'framer-motion';

export default function GameAssetsLoader() {
  return (
    <StyledGameAssetsLoader>
      <motion.div
        animate={{
          scale: [0.5, 0.6, 0.5],
        }}
        transition={{
          duration: 1,
          ease: 'easeInOut',
          repeat: Infinity,
        }}
      >
        <Image
          src={
            process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
            '/commonGameAssets/classic/bg-logo2.png'
          }
          width="318"
          height="55"
          alt=""
        />
      </motion.div>
    </StyledGameAssetsLoader>
  );
}
